// frontend/src/api.js
// Configuration automatique de l'API
// Utilise HTTPS en production pour éviter les problèmes de Mixed Content
const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:3001/api'
  : `${window.location.protocol}//${window.location.hostname}/api`;

export async function getPlayers() {
  const res = await fetch(`${API_URL}/players`);
  return res.json();
}

export async function getPostes() {
  const res = await fetch(`${API_URL}/postes`);
  return res.json();
}

export async function addPlayer(playerData) {
  const res = await fetch(`${API_URL}/players`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(playerData)
  });
  return res.json();
}

export async function updatePlayer(playerId, playerData) {
  const res = await fetch(`${API_URL}/players/${playerId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(playerData)
  });
  return res.json();
}

export async function deletePlayer(playerId) {
  const res = await fetch(`${API_URL}/players/${playerId}`, {
    method: 'DELETE'
  });
  return res.json();
}


export async function getMatchType() {
  const res = await fetch(`${API_URL}/match-types`);
  return res.json();
}

export async function getOngoingMatch() {
  try {
    const res = await fetch(`${API_URL}/matches/ongoing`);
    if (res.status === 404) {
      return null; // Pas de match en cours
    }
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return res.json();
  } catch (error) {
    console.error('Erreur getOngoingMatch:', error);
    return null;
  }
}

export async function deleteMatchStat(statId) {
  const res = await fetch(`${API_URL}/match-stats/${statId}`, {
    method: 'DELETE'
  });
  return res.json();
}

export async function deleteMatchSub(subId) {
  const res = await fetch(`${API_URL}/match-subs/${subId}`, {
    method: 'DELETE'
  });
  return res.json();
}

export async function fetchAPI(endpoint, options = {}) {
  // Si l'endpoint commence déjà par /api, ne pas ajouter API_URL
  const url = endpoint.startsWith('http') ? endpoint : 
              endpoint.startsWith('/api') ? `http://localhost:3001${endpoint}` :
              `${API_URL}${endpoint}`;
  
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  });
  
  if (!response.ok) {
    // Pour les endpoints qui peuvent retourner 404 (comme /matches/ongoing), on retourne null au lieu de lancer une erreur
    if (response.status === 404 && endpoint.includes('/ongoing')) {
      return null;
    }
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response.json();
}